import {
  StyledBankName,
  StyledBonusCode,
} from "../styledComponents/StyledDepositDialog";
import {
  StyledInput,
  StyledSelect,
} from "../styledComponents/CommonStyledComponents";
import {
  InvalidFeedback,
  StyledFormRow,
} from "../styledComponents/AccountPage";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useApolloClient } from "@apollo/client";
import {
  QUERY_GET_AVAILABLE_BONUSES,
  QUERY_GET_FREE_BETS,
} from "../graphql/queries";
// import {toast} from "react-toastify";

const FirstDepositBonusCodeDropdown = ({ skin, register, errors }) => {
  // const defaultFreeBetData = {
  //     uniqueID: -1,
  //     promoName: "",
  //     bonusCode: "",
  //     bonusTerms: "",
  //     bonusDescription: "",
  //     bonusImage: "",
  // };
  const { t, i18n } = useTranslation();
  const apolloClient = useApolloClient();
  const [freeBet, setFreeBet] = useState([]);
  const [welcomeBonuses, setWelcomeBonuses] = useState([]);

  useEffect(() => {
    const getFreeBets = async () => {
      const { loading, errors, data } = await apolloClient.query({
        query: QUERY_GET_FREE_BETS,
      });

      if (loading) return <h3>Loading ...</h3>;
      if (errors) {
        // console.log("error");
        console.log(t(errors[0].message));
        // toast.error(t(errors[0].message), {
        //     position: "bottom-center",
        // });
        return "error";
      }

      if (data.getFreeBets && data.getFreeBets.bonuses.length > 0) {
        setFreeBet(data.getFreeBets.bonuses);
      }
    };

    const getWelcomeBonuses = async () => {
      const { loading, errors, data } = await apolloClient.query({
        query: QUERY_GET_AVAILABLE_BONUSES,
      });

      if (loading) return <h3>Loading ...</h3>;
      if (errors) {
        console.log(t(errors[0].message));
        // toast.error(t(errors[0].message), {
        //     position: "bottom-center",
        // });
        return "error";
      }

      if (
        data.getAvailableBonuses &&
        data.getAvailableBonuses.bonuses.length > 0
      ) {
        const availableWelcomeBonuses = data.getAvailableBonuses.bonuses.filter(
          (bonus) => bonus.bonusType === "welcome"
        );
        if (availableWelcomeBonuses.length > 0) {
          // console.log("set welcome bonuses ", availableWelcomeBonuses);
          setWelcomeBonuses(availableWelcomeBonuses);
        }
      }
    };
    getFreeBets();
    if (skin === "yet" || skin === "cac" || skin === "hyc" || skin === "yak") {
      getWelcomeBonuses();
    }
  }, [skin]);
  return (
    <>
      {((skin !== "yet" &&
        skin !== "cac" &&
        skin !== "hyc" &&
        skin !== "yak") ||
        freeBet.length > 0 ||
        welcomeBonuses.length > 0) && (
        <StyledFormRow>
          <StyledBankName>
            <label>{t("label_bonus_code")}</label>
            <StyledSelect
              {...register("bonusCode", {
                required: t("err_select_bonus_option"),
              })}
              name="bonusCode"
              /* defaultValue={t("label_select_bonus")} */
            >
              <option value="">{t("label_select_bonus")}</option>
              {skin === "qbc" && (
                <option value={t("fdeposit-sports-bonus_code")}>
                  {t("fdeposit-sports-bonus_title")}
                </option>
              )}
              {freeBet.length > 0 &&
                freeBet.map((bonus) => {
                  return (
                    <option value={bonus.bonusCode}>{bonus.promoName}</option>
                  );
                })}
              {skin !== "yet" &&
                skin !== "cac" &&
                skin !== "hyc" &&
                skin !== "yak" && (
                  <option value={t("fdeposit-bonus_code")}>
                    {t("fdeposit-bonus_title")}
                  </option>
                )}
              {(skin === "yet" ||
                skin === "cac" ||
                skin === "hyc" ||
                skin === "yak") &&
                welcomeBonuses.length > 0 &&
                welcomeBonuses.map((bonus) => {
                  return (
                    <option value={bonus.bonusCode}>{bonus.promoName}</option>
                  );
                })}
              <option value="proceed">{t("fdeposit-no-bonus_title")}</option>
            </StyledSelect>
            <InvalidFeedback reg>{errors.bonusCode?.message}</InvalidFeedback>
          </StyledBankName>
        </StyledFormRow>
      )}
      {(skin === "yet" || skin === "cac" || skin === "hyc" || skin === "yak") &&
        freeBet.length === 0 &&
        welcomeBonuses.length === 0 && (
          <StyledFormRow>
            <StyledBonusCode>
              <label>{t("label_bonus_code")}</label>
              <StyledInput
                bonus
                type="text"
                name="bonusCode"
                {...register("bonusCode")}
                defaultValue={
                  typeof bonusCode !== "undefined" && bonusCode !== ""
                    ? bonusCode
                    : ""
                }
              ></StyledInput>
            </StyledBonusCode>
          </StyledFormRow>
        )}
    </>
  );
};

export default FirstDepositBonusCodeDropdown;
